import { normalize } from 'normalizr';
import { makeActionCreator } from 'utils/reduxCreators';

export const ADD_NORMALIZED_ENTITIES = 'normalizer/ADD_ENTITIES';
export const SET_NORMALIZED_ENTITIES = 'normalizer/SET_ENTITIES';

// Use this when entities must be completely replaced.
export const setEntities = makeActionCreator(SET_NORMALIZED_ENTITIES);

// Use this when entities must be deep merged instead of complete replacement.
export const setEntitiesWithNormalisation = (payload, schema) => {
  if (payload === null) throw new Error('Cannot normalise a null payload.');
  return setEntities(normalize(payload, schema));
};

// Use this when entities must be deep merged instead of complete replacement.
export const addEntities = makeActionCreator(ADD_NORMALIZED_ENTITIES);

// Use this when entities must be deep merged instead of complete replacement.
export const addEntitiesWithNormalisation = (payload, schema) => {
  if (payload === null) throw new Error('Cannot normalise a null payload.');
  return addEntities(normalize(payload, schema));
};
